import React from "react";
import Style from "./ExchangeRates.module.scss";
import { Link } from "react-router-dom";
import SwiperCore, { Mousewheel, Navigation, Autoplay, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useInView } from "react-intersection-observer";
import { useDimensions } from "../../logic/Dimensions";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

const ExchangeRates = ({ currencyRatesData }) => {
  const { t } = useTranslation(["common"]);
  const { width } = useDimensions();
  SwiperCore.use([Mousewheel, Navigation, Autoplay, FreeMode]);
  const isArabic = localStorage.getItem("lang") === "ar";
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  let filteredData = currencyRatesData?.details?.filter((item, i) => {
    return item?.currency_code !== "AED";
  });

  return (
    <div className={`${Style.exchangerates_sec} ${Style.loaded}  `}>
      <div className="container">
        <div className={`${Style.ratestitle}`}>
          <h2 ref={ref} className={`anim `}>
            {t("heading")}
          </h2>
        </div>
        <div className={Style.ratesecwrap}>
          <div className={Style.rateswrap}>
            <Swiper
              className={`${Style.rateslider} ${isArabic ? Style.arabic_font_size : ""}`}
              loop={true}
              slidesPerView={"auto"}
              speed={3000}
              freeMode={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                0: {
                  spaceBetween: 20,
                },
                768: {
                  spaceBetween: 60,
                },
                992: {
                  spaceBetween: 100,
                },
                1200: {
                  spaceBetween: 160,
                },
                1600: {
                  spaceBetween: 210,
                },
              }}
            >
              {currencyRatesData?.details &&
                currencyRatesData?.details?.length > 0 &&
                filteredData?.map((value, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <div className={Style.rateitem} key={i}>
                        <figure className={Style.flag}>
                          <img src={value?.country_flag}  alt="Country_flag"/>
                        </figure>
                        <div className={Style.countryname}>
                          {isArabic ? value?.["title-ar"] : value?.title}
                        </div>
                        <div className={Style.rates}>
                          {isArabic
                            ? value?.exchange_rate_ar
                            : value?.exchange_rate}&nbsp;
                          <span className={Style.currency}>
                            {isArabic
                              ? value?.currency_code_ar
                              : value?.currency_code}
                          </span>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
        <div className={Style.ratescnt}>
          <p>
            {t("exchangeRateSubtitle")}
      
          </p>
          {width >= 768 && (
            <Link
              to="services/currency-exchange#section-rate"
              className={`btn btn-brdr ${Style.viewall}`}
            >
              <span>{t("buttonViewAll")}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExchangeRates;
